<template>
  <SplitViewTemplate 
    :screenConfig="data" 
    :backButtonRoute="'/settings/production'" 
    :dataModel="formModel"
    :formConfig="setFormConfig" 
    :setLoading="setLoading" 
    :validationSummary="validationSummary"
    :ref="'labour-resources'" 
    :defaultUserSettings="false" />
</template>
<script>
import { FeatureStorage } from "@/_services/storage";
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
import { DepartmentService } from "../../../_services/api/sales/department.service";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        Code: null,
        Inactive: false,
        DepartmentCode: null,
        LabourGroupCode: null,
        Status: "A",
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Labour Resources",
        pageRoute: "/labour-resources",
        saveEndPoint: "LabourResource",
        updateEndPoint: "LabourResource",
        updateKeyField: "Code",
        updateKeyFieldType: "string",
        recordEndPoint: "LabourResource",
        exportFileName: "Labour Resource",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "LabourResourceList",
              serverPaging: true,
              allowGrouping: false,
              filter: "",
              sort: [{ selector: "UserFullName", desc: false }],
            },
            rowSelect: {
              view: this,
              page: "labour-resources",
              mode: "review",
              idProperty: "Code",
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/labour-resources/create",
                clickAction: () => {
                  this.goToCreateLabourResources();
                },
                buttonLocation: "left",
                // disabled: false,
                visible: FeatureStorage.checkPermission(
                  "ProductionSettings",
                  "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "LabourResource",
              allowHiding: false,
              sortIndex: 0,
              sortOrder: "asc",
              gridDataField: "UserFullName",
              dataField: "UserFullName",
            },
            {
              screenField: "NormalRate",
            },
            {
              screenField: "NormalRate",
              filterIndex: 1,
              showInColumnChooser: false,
              visible: false,
              intOperators: true,
              type: "Integer",
            },
            {
              screenField: "ResourceRate",
            },
            {
              screenField: "ResourceRate",
              filterIndex: 2,
              visible: false,
              showInColumnChooser: false,
              intOperators: true,
              type: "Integer",
            },
            {
              screenField: "Department",
              dataField: "DepartmentSearchText",
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "DepartmentDesc",
                  },
                ],
                secondary: [
                  {
                    dataField: "DepartmentCode",
                  },
                ],
              },
              exportFields: [
                {
                  "dataField": "DepartmentCode",
                  "label": "Department Code",
                  "alignment": "left"
                },
                {
                  "dataField": "DepartmentDesc",
                  "label": "Department Description"
                },
              ],
              filterIndex: 3,
              filterDataField: "DepartmentCode",
            },
            {
              screenField: "LabourGroup",
              label: "Labour Group",
              dataField: "LabourGroupSearchText",
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "LabourGroupDesc",
                  },
                ],
                secondary: [
                  {
                    dataField: "LabourGroupCode",
                  },
                ],
              },
              exportFields: [
                {
                  "dataField": "LabourGroupCode",
                  "label": "Labour Group Code"
                },
                {
                  "dataField": "LabourGroupDesc",
                  "label": "Labour Group Description"
                },
              ],
              filterIndex: 4,
              filterDataField: "LabourGroupCode",
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 0,
            },
          ],
          valueChangedEventListners: [],
        },
        recordPostProcess: this.recordPostProcess,
      },
      updatedDefaultRecordId: undefined,
      recordEditable: true,
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: FeatureStorage.checkPermission(
            this.$route.meta.applicationFeatureCode,
            "create"
          ),
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: false,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
          editCallBack: () => {
            this.beforeInit();
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                editorType: "dxTextBox",
                editorOptions: {
                  tabIndex: 1,
                  maxLength: 7,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Code" },
                visible: true,
                allowUpdate: this.baseView.mode == "create" ? true : false,
              },
              {
                dataField: "FirstName",
                editorType: "dxTextBox",
                editorOptions: {
                  tabIndex: 2,
                  maxLength: 50,
                },
                required: true,
                label: { text: "First Name" },
                visible: true,
                allowUpdate: this.recordEditable,
              },
              {
                dataField: "Surname",
                editorType: "dxTextBox",
                editorOptions: {
                  tabIndex: 3,
                  maxLength: 50,
                },
                required: true,
                label: { text: "Surname" },
                visible: true,
                allowUpdate: this.recordEditable,
              },
              {
                screenField: "ResourceRate",
                editorType: "dxNumberBox",
                editorOptions: {
                  tabIndex: 4,
                },
                required: true,
                visible: true,
                allowUpdate: this.recordEditable,
                validationRules: [
                  {
                    type: "range",
                    message: "Resource Rate must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                screenField: "NormalRate",
                editorType: "dxNumberBox",
                editorOptions: {
                  tabIndex: 5,
                },
                required: true,
                visible: true,
                allowUpdate: this.recordEditable,
                validationRules: [
                  {
                    type: "range",
                    message: "Normal Rate must be greater than or equal to 0",
                    min: 0,
                  },
                ],
              },
              {
                dataField: "DepartmentCode",
                label: { text: "Department" },
                editorType: "dxSelectBox",
                required: true,
                editorOptions: {
                  tabIndex: 6,
                  dataSource: DepartmentService.dataSourceConfig(
                    "api/DepartmentList",
                    {
                      select: ["Code", "Description"],
                      filter: this.baseView.mode == "create" ?
                        ["Inactive", "=", "N"] :
                        [
                          [
                            "Code",
                            "=",
                            this.formModel["DepartmentCode"]
                          ],
                          "or",
                          ["Inactive", "=", "N"]
                        ],
                      sort: [{ selector: "Description", asc: true }],
                    }
                  ),
                  valueExpr: "Code",
                  displayExpr: (item) => {
                    if (item) return item.Description + " - " + item.Code;
                    else return "";
                  },
                  itemTemplate: (data) => {
                    return ` <div class="custom-auto-complete" id="${data.Code}" >
                      <span class="auto-complete-primary">
                        ${data.Description}
                      </span>
                      <span class="record-secondary gc-grid-code">
                        ${data.Code}
                      </span> 
                    </div>`;
                  },
                  searchExpr: ["SearchText"],
                  searchMode: "contains",
                  showClearButton: true,
                  searchEnabled: true,
                },
              },
              {
                dataField: "LabourGroupCode",
                label: { text: "Labour Group" },
                editorType: "dxSelectBox",
                required: true,
                editorOptions: {
                  tabIndex: 7,
                  dataSource: DepartmentService.dataSourceConfig(
                    "api/LabourGroup",
                    {
                      select: ["Code", "Description"],
                      filter: this.baseView.mode == "create" ?
                        ["Inactive", "=", "N"] :
                        [
                          [
                            "Code",
                            "=",
                            this.formModel["LabourGroupCode"]
                          ],
                          "or",
                          ["Inactive", "=", "N"]
                        ],
                      sort: [{ selector: "Description", asc: true }],
                    }
                  ),
                  valueExpr: "Code",
                  displayExpr: (item) => {
                    if (item) return item.Description + " - " + item.Code;
                    else return "";
                  },
                  itemTemplate: (data) => {
                    return ` <div class="custom-auto-complete" id="${data.Code}" >
                      <span class="auto-complete-primary">
                        ${data.Description}
                      </span>
                      <span class="record-secondary gc-grid-code">
                        ${data.Code}
                      </span> 
                    </div>`;
                  },
                  searchExpr: ["Code", "Description"],
                  searchMode: "contains",
                  showClearButton: true,
                  searchEnabled: true,
                },
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
  },
  methods: {
    goToCreateLabourResources() {
      this.$router
        .push({
          path: `/labour-resources/create`,
        })
        .then(() => {
          this.recordEditable = true;
        });
    },
    beforeInit() {
      this.recordEditable = true;
    },
    overWritePayload(payload) {
      payload.Status = "A";
      return payload;
    },
    recordPostProcess(data) {
      return data;
    },
  },
  created() {
    this.beforeInit();
  },
};
</script>
